module.exports = __webpack_public_path__ + "456888eba7703182c8ec76333ed89040.svg";